import React from 'react';
import { Handle, Position } from 'reactflow';
import useSyncNodeInternals from '../Components/useSyncNodeInternals';

import { MdOutlineSupportAgent } from 'react-icons/md';
import NodeCardShell from '../Components/NodeCardShell';

const TRANSFER_NODE_COLOR = '#F56F89';

const TransferAgent = ({ data, isConnectable, id, selected }) => {
  useSyncNodeInternals(id, `${data.saved}~${data.first}`);

  return (
    <NodeCardShell
      icon={MdOutlineSupportAgent}
      color={TRANSFER_NODE_COLOR}
      typeName="Transferir Agente"
      title={data.title ?? 'Transferir Conversación'}
      summary={data.agent_area?.label}
      trigger={data.user_response}
      error={data?.error}
      selected={selected}
      first={data.first}
      handles={
        <>
          {!data.first && data.saved && (
            <Handle
              type="target"
              position={Position.Top}
              isConnectable={isConnectable}
              id={`target-${id}`}
              style={{ backgroundColor: TRANSFER_NODE_COLOR }}
            />
          )}
          {data.saved && (
            <Handle
              type="source"
              position={Position.Bottom}
              id={`source-${id}`}
              isConnectable={isConnectable}
              style={{ backgroundColor: TRANSFER_NODE_COLOR }}
            />
          )}
        </>
      }
    />
  );
};

export default React.memo(TransferAgent);
